import { StartWorkflowPage } from './StartWorkflowPage';

export function DurableInvokePage() {
  return <StartWorkflowPage />;
}
